var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.emailAddresses.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "registration-email-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.emailAddresses), function(emailAddr) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(emailAddr.email) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(emailAddr.default === true ? 'výchozí' : '') + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(emailAddr.note) + "\n              ")])])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-email-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.email),
      expression: "emailAddress.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e-mailová adresa",
      "id": "emailAddress",
      "data-testid": "registration-email-address"
    },
    domProps: {
      "value": (_vm.emailAddress.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        Výchozí: \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.default),
      expression: "emailAddress.default"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Checkbox for following text input",
      "data-testid": "registration-email-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.emailAddress.default) ? _vm._i(_vm.emailAddress.default, null) > -1 : (_vm.emailAddress.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.emailAddress.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.emailAddress.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.emailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.emailAddress.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.note),
      expression: "emailAddress.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "emailAddressNote",
      "data-testid": "registration-email-note",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.emailAddress.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailAddressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-email-add"
    }
  }, [_vm._v("Přidat e-mail")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.emailAddressError.email) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "numberError",
      "data-testid": "registration-email-error"
    }
  }, [_vm._v(_vm._s(_vm.emailAddressError.email.message))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.emailAddressPending || _vm.emailAddressesPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "registration-email-next"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Další krok "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("E-mailová adresa")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6413c948","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/components/RegistrationClientEmail.vue
// module id = 467
// module chunks = 0